import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Section from 'components/common/Section';
import { getImageUrlOfConfig } from 'y4/Falcon';
import is from 'is_js';

const Cta = ({ configs }) => {
  if (is.empty(configs)) return null;
  const c = configs[0];
  const i_bg = getImageUrlOfConfig(c);

  return (
    <Section
      overlay
      image={i_bg}
      position="center top"
      className="light bg-dark"
    >
      <Row className="justify-content-center text-center">
        <Col lg={8}>
          <p className="fs-3 fs-sm-4 text-white">{c.caption}</p>
          <Button
            as={Link}
            variant="outline-light"
            size="lg"
            className="border-2 rounded-pill mt-4 fs-0 py-2"
            to={c.url}
          >
            {c.title}
          </Button>
        </Col>
      </Row>
    </Section>
  );
};
Cta.propTypes = {
  configs: PropTypes.array
};
export default Cta;
